import React from "react";
import { Box, InputLabel, Typography } from "@mui/material";
import TextFieldComponent from "components/input/TextFieldComponent";
import ButtonComponent from "components/button/ButtonComponent";
import { MESSAGE } from "constants/validate";
import "./ChangePassword.css";
import useChangePassword from "../hooks/useChangePassword";
import Header from "../../../components/Header";

/**
 *
 */
function ChangePassword() {
  const {
    password,
    passwordConfirm,
    disabledSubmit,
    clearError,
    handleSubmit,
    setPassword,
    setPasswordConfirm,
    setErrors,
  } = useChangePassword();

  return (
    <>
      <Header showMenu={false} />
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          height: "calc(100vh - 100px)",
          bgcolor: "background.paper",
          p: 3,
        }}
      >
        <Box justifyItems="center" paddingY="67px">
          <img src="/img/login/yhbb_login_top.png" alt="YHBB Login" />
          <Typography
            variant="h2"
            sx={{
              fontSize: "31px",
              paddingTop: "67px",
              fontWeight: "medium",
              color: "var(--gray-700)",
            }}
          >
            パスワード変更画面
          </Typography>
        </Box>
        <form onSubmit={handleSubmit} className="change-password-form">
          <Box display="flex" justifyContent="center">
            <Box
              display="flex"
              gap="57px"
              alignItems="center"
              justifyContent="space-between"
              width="550px"
            >
              <InputLabel
                htmlFor="currentPassword"
                sx={{
                  fontSize: "23px",
                  color: "var(--black)",
                  fontWeight: "medium",
                  textOverflow: "initial",
                }}
              >
                新規パスワード
              </InputLabel>
              <TextFieldComponent
                type="password"
                sx={{
                  width: "240px",
                }}
                sxRoot={{
                  borderRadius: "4px",
                }}
                sxNotchedOutline={{
                  borderColor: "var(--gray-250)",
                }}
                value={password}
                validateOption={{
                  required: {
                    message: MESSAGE.EMPTY_PASSWORD,
                  },
                  minLength: {
                    value: 8,
                    message: MESSAGE.VALIDATION_PASSWORD(8),
                  },
                  // includeNumber: {
                  //   message: MESSAGE.VALIDATION_PASSWORD(8),
                  // },
                  // includeAlphabet: {
                  //   message: MESSAGE.VALIDATION_PASSWORD(8),
                  // },
                  halfWidth: {
                    message: MESSAGE.VALIDATION_PASSWORD(8),
                  },
                }}
                onChangeText={setPassword}
                onError={(error) => setErrors((pre) => ({ ...pre, password: error }))}
              />
            </Box>
          </Box>

          <Box display="flex" justifyContent="center">
            <Box
              display="flex"
              gap="57px"
              alignItems="center"
              justifyContent="space-between"
              marginTop="32px"
              width="550px"
            >
              <InputLabel
                htmlFor="newPassword"
                sx={{
                  fontSize: "23px",
                  color: "var(--black)",
                  fontWeight: "medium",
                  textOverflow: "initial",
                }}
              >
                新規パスワード（確認）
              </InputLabel>
              <TextFieldComponent
                sx={{
                  width: "240px",
                }}
                sxRoot={{
                  borderRadius: "4px",
                }}
                sxNotchedOutline={{
                  borderColor: "var(--gray-250)",
                }}
                clearError={clearError}
                type="password"
                value={passwordConfirm}
                validateOption={{
                  required: {
                    message: MESSAGE.EMPTY_PASSWORD,
                  },
                  minLength: {
                    value: 8,
                    message: MESSAGE.VALIDATION_PASSWORD(8),
                  },
                  sameValue: {
                    value: password,
                    message: MESSAGE.NOT_SAME_PASSWORD,
                  },
                  // includeNumber: {
                  //   message: MESSAGE.VALIDATION_PASSWORD(8),
                  // },
                  // includeAlphabet: {
                  //   message: MESSAGE.VALIDATION_PASSWORD(8),
                  // },
                  // halfWidth: {
                  //   message: MESSAGE.VALIDATION_PASSWORD(8),
                  // },
                }}
                onError={(error) => setErrors((pre) => ({ ...pre, passwordConfirm: error }))}
                onChangeText={setPasswordConfirm}
              />
            </Box>
          </Box>
          <ButtonComponent
            disabled={disabledSubmit}
            label="変更する"
            theme="dark"
            type="submit"
            sx={{
              marginTop: "86px",
              width: "240px",
            }}
          />
          <Typography
            sx={{
              paddingTop: "38px",
              textDecoration: "underline",
              color: "var(--black)",
            }}
            fontWeight="fontWeightRegular"
            fontSize="20px"
          >
            設定後有効期限は1ヶ月です
          </Typography>
        </form>
      </Box>
    </>
  );
}

export default ChangePassword;
